<template>
    <main id="main" 
        :style="css_props"
    >
        <v-row
            no-gutters
            class="main__container"
        >
            <v-col class="display-block__wrapper" 
                ref="display_block"
            >
                <!-- 多用一個 component 去包，因應將來會發生的監控地圖互動  -->
                <DisplayBlock
                    :is_show_favorites="is_show_favorites"
                />
                <Notifications 
                    :system_information="information"
                />
                <ToggleMenuBtn 
                    class="main-block-options__btn__menu--mobile"
                    v-show="is_hide_menu"
                    :is_hide_menu.sync="is_hide_menu"
                    @trigger_menu_display="toggle_menu"
                />
            </v-col>
            <div 
                class="main-block-options__background" 
                :class="{
                    'main-block-options__background--other': this.last_selected_main_menu !== 'emap',
                    'main-block-options__background--map-monitor': is_monitor_open_emap,
                    'main-block-options__content--hide_menu': is_hide_menu
                }"
            >
                <div class="main-block-options__content">
                    <v-row
                        justify="center"
                        align-content="space-around"
                        no-gutters
                    >
                        <v-col 
                            cols="12"
                            class="main-block-options__btn main-block-options__btn__menu"
                        >
                            <ToggleMenuBtn 
                                :is_hide_menu.sync="is_hide_menu"
                                @trigger_menu_display="toggle_menu"
                            />
                        </v-col>
                        <v-col 
                            v-for="(menu, index) in main_menu" 
                            :key="index"
                            cols="12" 
                            class="main-block-options__btn main-block-options__btn__block"
                            :class="{
                                'main-block-options__btn__block--active': selected_main_menu === menu.name,
                            }"
                        >    
                            <QpeTooltip v-if="menu.tooltip_text">
                                <template #hovered_item>
                                    <div 
                                        class="menu-btn"
                                        :class="{
                                            active: selected_main_menu === menu.name,
                                            unactive: selected_main_menu !== menu.name
                                        }"
                                        @click="menu.func"
                                    >
                                        <v-icon size="32">
                                            {{ menu.icon }}
                                        </v-icon>
                                        <span>{{ menu.text }}</span>
                                    </div>
                                </template>
                                <template 
                                    #tooltip_content
                                >
                                    <span>{{ menu.tooltip_text }}</span>
                                </template>
                            </QpeTooltip>
                            <div 
                                v-else
                                class="menu-btn"
                                :class="{
                                    active: selected_main_menu === menu.name,
                                    unactive: selected_main_menu !== menu.name
                                }"
                                @click="menu.func"
                            >
                                <v-icon size="32">
                                    {{ menu.icon }}
                                </v-icon>
                                <span>{{ menu.text }}</span>
                            </div>
                        </v-col>
                        <v-col v-if="is_hide_previous_btn"
                            cols="12" 
                            class="main-block-options__btn main-block-options__btn__block"
                        >
                            <a 
                                :href="`/${previous_client_name}`"
                                target="_blank"
                                class="menu-btn"
                            >
                                <v-icon size="32">
                                    mdi-launch
                                </v-icon>
                                <span>{{ $t('__menu.previous') }}</span>
                            </a>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <aside v-show="!is_hide_menu" 
                class="main-menu__container"
            >
                <MainMenu 
                    ref="main_menu"
                    :atlas_menu_data="atlas_menu_data"
                    :selected_main_menu="selected_main_menu"
                    @transfer-information="transfer_information"
                />
            </aside>
        </v-row>

        <!-- 維修訊息，現在沒有串接，先做 UI -->
        <FullpageHint v-if="false"
            title="系統因需進行硬體更新，預計於 12:00~12:30 進行維修(尚須接資料)"
            content="屆時用戶無法使用，請及早因應，造成不便敬請見諒"
            :is_show_confirm_btn="true"
        />
        <FullpageHint v-if="is_mobile_landscape"
            :title="$t('__fullpage_hint.landscape_title')"
            :content="$t('__fullpage_hint.landscape_content')"
            :is_show_confirm_btn="true"
        />
    </main>
</template>

<script>
    import { fire_resize } from '@/utils/emap/lib.js'
    import { atlas_menu_ajax } from '@/utils/atlas/atlas.js'
    import { get_previous_link_ajax } from '@/utils/emap/emap_init.js'
    import { mapState, mapGetters, mapMutations } from 'vuex'
    import { STATIC_SVG_ROOT } from '@/config/config.js'
    import DisplayBlock from '@/components/display_block.vue'
    import MainMenu from '@/components/menu_common/main_menu.vue'

    export default {
        name: 'MainPage',

        components: {
            DisplayBlock, 
            MainMenu, 
            QpeTooltip: () => import('@/components/tool/qpe_tooltip.vue'),
            Notifications: () => import('@/components/notification/notifications.vue'),
            ToggleMenuBtn: () => import('@/components/common/toggle_menu_btn.vue'),
            FullpageHint: () => import('@/components/notification/fullpage_hint.vue'),
        },

        data() {
            return {
                is_totally_confirmed_landscape: false,

                atlas_menu_data: {},                
                STATIC_SVG_ROOT: STATIC_SVG_ROOT,

                selected_main_menu: 'emap',
                last_selected_main_menu: 'emap',

                information: [],

                resize_observer: null,

                is_hide_previous_btn: false,
                previous_client_name: '',

                // 我的最愛
                is_show_favorites: true,
            }
        },

        computed: {
            ...mapState([
                'client_name',
                'language',
                'i18n_language',
                'height',
            ]),

            ...mapState('emap-monitor', [
                'is_monitor_open_emap',
            ]),

            ...mapGetters([
                'is_activate_i18n',
                'is_pub',
                'is_mobile_width',
                'is_pad_width',
            ]),

            is_hide_menu: {
                get() {
                    return this.$store.state.emap.is_hide_menu
                },

                set(value) {
                    this.$store.commit('emap/set_is_hide_menu', value)
                }
            },
            
            css_props() {
                return {
                    '--app-height': `${this.height}px`,
                } 
            },

            is_show_atlas_tab() {
                return Object.keys(this.atlas_menu_data).length > 0
            },

            main_menu() {
                const monitor_text = this.is_pub ? this.$t('__menu.table_pub') : this.$t('__menu.table')
                const monitor_tooltip = this.is_pub && this.language === 'en' && 'Observation'
                const basic_menu_options = [
                    { 'name': 'emap', 'icon': 'icon-map', 'text': `${this.$t('__menu.map')}`, 'func': this.change_to_map },
                    { 'name': 'monitor', 'icon': 'icon-monitor', 'text': monitor_text, 'tooltip_text': monitor_tooltip, 'func': this.change_to_monitor },
                    { 'name': 'about', 'icon': 'icon-about', 'text': `${this.$t('__menu.about')}`, 'func': this.change_to_about },
                ]
                
                if(this.is_show_atlas_tab) {
                    const atlas_option = { 'name': 'atlas', 'icon': 'icon-gallery', 'text': '圖輯', 'func': this.change_to_atlas }
                    basic_menu_options.splice(1, 0, atlas_option)
                }

                if(!this.is_pub) {
                    const account_option = { 'name': 'account', 'icon': 'icon-account-circle', 'text': `${this.$t('__menu.account')}`, 'func': this.change_to_account }
                    basic_menu_options.splice(-1, 0, account_option)
                }

                if(this.is_activate_i18n) {
                    const language_setting_option = { 
                        'name': 'language_setting', 
                        'icon': 'mdi-google-translate', 
                        'text': `${this.$t('__menu.language')}`, 
                        'func': this.change_to_language_setting,
                        'tooltip_text': this.language === 'tw' ? 'language' : ''
                    }
                    basic_menu_options.splice(-1, 0, language_setting_option)
                }

                return basic_menu_options
            },

            is_mobile_landscape() {
                return this.height < 769 && this.is_totally_confirmed_landscape
            },
        },

        watch: {
            is_hide_menu() {
                const toolDOM = document.querySelector('.map-ctrl.map-top-right-ctrl')
                const notificationDOM = document.querySelector('.notification-btn')
                // 用 vanilla js，操作在 kxd component裡面的 map tool dom，避免更改到 kxd
                if (!toolDOM || !notificationDOM) return

                const tool_class_name = 'laptop-map-toolbar'
                const notification_class_name = 'laptop-notification'
                if (!this.is_hide_menu) {
                    toolDOM.classList.add(tool_class_name)
                    notificationDOM.classList.add(notification_class_name)
                    return
                }
                if (toolDOM.classList.contains(tool_class_name)) toolDOM.classList.remove(tool_class_name)
                if (notificationDOM.classList.contains(notification_class_name)) notificationDOM.classList.remove(notification_class_name)
            }
        },

        async mounted() {
            this.init_layout_variable()
            !this.resize_observer && this.start_resize_observer()
            this.is_hide_menu = this.is_mobile_width || this.is_pad_width
            
            await this.init_atlas_to_judge_whether_enable()
            
            const tab = new URL(location.href).searchParams.get('tab')
            
            tab === 'atlas' && this.$nextTick(() => {
                this.change_to_atlas()
            }) 
            tab === 'monitor' && this.$nextTick(() => {
                this.change_to_monitor()
            })

            this.init_previous_link()
        },

        beforeDestroy() {
            this.resize_observer.unobserve(this.$refs.display_block)
        },

        methods: {
            ...mapMutations([
                'set_display_block_width',
                'set_window_boundary',
            ]),

            ...mapMutations('atlas', [
                'set_atlas_loaded',
                'set_atlas_state',
            ]),

            ...mapMutations('monitor', [
                'set_monitor_loaded',
                'set_monitor_state',
            ]),

            async init_previous_link() {
                try {
                    const response = await get_previous_link_ajax(this.client_name);
                    const data = response.data
                    this.is_hide_previous_btn = data.previous
                    this.previous_client_name = data.previous ? data.layout : ''
                } catch(err) {
                    console.error(err)
                }
            },

            async init_atlas_to_judge_whether_enable() {
                try {
                    const response = await atlas_menu_ajax(this.client_name)
                    const atlas_menu_response = typeof response.data === 'object' ? response.data : JSON.parse(response.data);
                    this.atlas_menu_data = atlas_menu_response.data
                } catch(err) {
                    console.error(err)
                }
            },
            
            toggle_menu() {
                this.$nextTick(() => {
                    this.set_display_block_width(this.$refs.display_block.clientWidth);
                });
                this.selected_main_menu === 'emap' && fire_resize();
            },
        
            change_to_map() {
                this.selected_main_menu = 'emap'
                this.last_selected_main_menu = this.selected_main_menu
                this.is_show_favorites = true;
                this.set_atlas_state(false);
                this.set_monitor_state(false);
                window.history.pushState('state_object', 'Map', '?tab=emap');

                setTimeout(() => {
                    fire_resize();
                }, 1000)
            },
            
            change_to_atlas() {
                this.selected_main_menu = 'atlas'
                this.last_selected_main_menu = this.selected_main_menu
                this.is_show_favorites = false;
                this.set_atlas_loaded(true);
                this.set_atlas_state(true);
                this.set_monitor_state(false);
                window.history.pushState('state_object', 'Atlas', '?tab=atlas');
            },

            change_to_monitor() {
                this.selected_main_menu = 'monitor'
                this.last_selected_main_menu = this.selected_main_menu
                this.is_show_favorites = false;
                this.set_monitor_loaded(true);
                this.set_monitor_state(true);
                this.set_atlas_state(false);
                window.history.pushState('state_object', 'Atlas', '?tab=monitor');
            },

            change_to_account() {
                this.selected_main_menu = 'account'
            },

            change_to_language_setting() {
                this.selected_main_menu = 'language_setting'
            },

            change_to_about() {
                this.selected_main_menu = 'about'
            },

            transfer_information(information) {
                this.information = information
            },

            start_resize_observer() {
                this.resize_observer = new ResizeObserver(() => {
                    this.init_layout_variable()
                })
                this.resize_observer.observe(this.$refs.display_block)
            },

            init_layout_variable() {
                this.set_display_block_width(this.$refs.display_block.clientWidth);
                this.set_window_boundary({
                    width: window.innerWidth,
                    height: window.innerHeight,
                })
                const is_hoverable = window.matchMedia("(hover: hover)").matches
                const is_small_width = window.matchMedia("(max-width: 1024px)").matches
                const is_landscape = window.matchMedia("(orientation: landscape)").matches
                this.is_totally_confirmed_landscape = !is_hoverable && is_small_width && is_landscape
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../css/mixin';

    .display-block__wrapper {
        position: relative;

        @include desktop {
            // 為了避免表格 th no-wrap 時會縮小選單的問題
            width: calc(77% - 4rem);
        }

        @include laptop {
            position: fixed;
            height: 100%;
        }
    }

    .main__container {
        flex-wrap: nowrap;
        height: 100%;
    }

    .main-block-options {
        &__background {
            position: relative;
            z-index: 2;
            height: 100vh;
            background: #000;
            touch-action: none;

            &--other {
                background: #fff;
            }

            &--map-monitor {
                background: linear-gradient(to bottom, #000, #fff);
            }
        }

        &__content {
            position: relative;
            width: 4rem;
            height: 100%;
            background: var(--base-dark-blue);
            border-radius: 1rem 0 0 1rem;
            box-shadow: .25rem 0 .5rem 0 rgba(0, 0, 0, .32);

            @include laptop {
                position: fixed;
                right: 40%;
                height: var(--app-height);
            }

            @include mobile {
                right: 70%;
            }

            &--hide_menu {
                @include laptop {
                    display: none;
                }
            }
        }

        &__btn {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            color: var(--grey-pipe) !important;

            &--active {
                color: var(--aqua-active) !important;
            }

            &__menu {
                height: 3rem;

                &--mobile {
                    @include desktop {
                        display: none;
                    }

                    @include laptop {
                        position: absolute;
                        top: 0;
                        right: 0;
                        margin: 0 .75rem;
                        padding: .5rem;
                        z-index: 1;
                    }
                }
            }

            &__block {
                height: 80px;
                border-left: 2px solid transparent;

                &--active {
                    color: var(--aqua-active) !important;

                    &::after {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 0;
                        display: block;
                        width: 3px;
                        height: 40%;
                        background: var(--aqua-active);
                        border-radius: 3px;
                        pointer-events: none;
                        transform: translate(0, -50%);
                    }
                }
            }
        }
    }

    .menu-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        text-align: center;
        transform: translate(-50%, -50%);
    }

    a.menu-btn {
        color: var(--grey-pipe);
        text-decoration: none;
    }

    .main-menu__container {
        position: relative;
        z-index: 2;
        width: 23%;
        height: 100vh;
        background-color: #454d66;
        touch-action: none;

        @include laptop {
            position: fixed;
            right: 0;
            width: 40%;
            height: var(--app-height);
        }

        @include mobile {
            width: 70%;
        }
    }
</style>

<style scoped>
    .main-block-options__btn >>> .v-icon {
        color: var(--grey-pipe);
    }

    .menu-btn.active >>> .v-icon {
        color: var(--aqua-active);
    }
</style>

<style>
    .map-pane-tag {
        margin: 0.5rem 3.35rem 0 0.35rem !important;
    }

    .kxd-map-container .map-right-top-ctrl {
        align-items: flex-end !important;
        flex-direction: column-reverse !important;
    }

    .capture-img {
        width: 45% !important;
        margin: 0 !important;
    }

    .kxd-map-container .capture-img__container {
        margin: 0 10px 10px 0 !important;
    }

    @media only screen and (max-width: 1264px) and (min-width: 768px) {
        .map-ctrl.map-top-right-ctrl.laptop-map-toolbar,.notifications .notification-btn.laptop-notification {
            position: fixed;
            z-index: 3 !important;
        }

        .map-ctrl.map-top-right-ctrl.laptop-map-toolbar {
            top: 50px;
            right: calc(40% + 4rem);
        }

        .notifications .notification-btn.laptop-notification {
            top: 10px;
            right: calc(40% + 4rem + 13px);
        }
    }
</style>